<ng-container *ngIf="(translationsInitialized$ | async) && currentView$ | async as view; else loadingBlock">
  <ng-container [ngSwitch]="view">
    
    <ng-container *ngSwitchCase="AppView.Antipattern">
      <ap-antipattern-popup />
    </ng-container>
    <ng-container *ngSwitchCase="AppView.AntipatternV2">
      <ap-antipattern-popup-v2 />
    </ng-container>
    <ng-container *ngSwitchCase="AppView.Notification">
      <ui-notification-popup />
    </ng-container>

  </ng-container>
</ng-container>
<ng-template #loadingBlock>
  <ui-app-loader />
</ng-template>
